import { render, staticRenderFns } from "./LastJobs.html?vue&type=template&id=438f29af&scoped=true&"
import script from "./LastJobs.vue?vue&type=script&lang=js&"
export * from "./LastJobs.vue?vue&type=script&lang=js&"
import style0 from "./LastJobs.scss?vue&type=style&index=0&id=438f29af&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f29af",
  null
  
)

export default component.exports